import { useParams } from 'react-router';
import { Col, Flex, Row } from 'antd';
import { useQuery } from '@apollo/client/react';

import TermsDescriptions from './TermsDescriptions';
import AssistanceDescriptions from './AssistanceDescriptions';
import BankruptcyLegalDescriptions from './BankruptcyLegalDescriptions';
import CardDetailsDescriptions from './CardDetailsDescriptions';
import RewardsDescriptions from './RewardsDescriptions';
import SecuredDescriptions from './SecuredDescriptions';

import QueryBoundary from 'components/QueryBoundary/QueryBoundary';
import useAccountQuery from 'hooks/useAccountQuery';
import { ACCOUNT_PRICING_DETAILS, GET_ACCOUNT_REWARDS } from 'queries/account';

const CreditDetailsSection = () => {
  const { accountId, customerId } = useParams();

  const { accountQuery, account, accountInDebtSale, simpleAccount } =
    useAccountQuery(customerId, accountId);

  const pricingDetailsQuery = useQuery(ACCOUNT_PRICING_DETAILS, {
    variables: { customerId, accountId },
  });

  const rewardsQuery = useQuery(GET_ACCOUNT_REWARDS, {
    // only load rewards if isRewards
    // also skip when switching from rewards to non-rewards accounts for multi-card customers
    skip: account?.id !== accountId || account?.isRewards !== true,
    variables: { customerId, accountId },
  });

  return (
    <QueryBoundary
      errorMessage="Failed to load account details."
      query={accountQuery}
      loadingOverride={pricingDetailsQuery.loading}
    >
      <Row gutter={[8, 12]}>
        <Col span={24} xl={8}>
          <Flex vertical={true} gap="var(--spacing-sm)">
            <CardDetailsDescriptions
              account={account}
              simpleAccount={simpleAccount}
            />
            <BankruptcyLegalDescriptions />
            <SecuredDescriptions account={account} />
          </Flex>
        </Col>
        <Col span={24} xl={8}>
          <Flex vertical={true} gap="var(--spacing-sm)">
            <TermsDescriptions
              account={account}
              pricingDetails={
                pricingDetailsQuery?.data?.account?.pricingDetails
              }
            />
            {account?.isRewards && (
              <RewardsDescriptions
                rewards={rewardsQuery?.data?.account?.rewardsV2}
                rewardsFailure={rewardsQuery?.error}
              />
            )}
          </Flex>
        </Col>
        <Col span={24} xl={8}>
          <Flex vertical={true} gap="var(--spacing-sm)">
            <AssistanceDescriptions
              account={account}
              accountInDebtSale={accountInDebtSale}
            />
          </Flex>
        </Col>
      </Row>
    </QueryBoundary>
  );
};

export default CreditDetailsSection;
